<div class="avatar-container" (click)="triggerFileInput()">
  <img
    [src]="preview || defaultImage"
    class="avatar-image"
    alt="Avatar"
  />

  <input
    #fileInput
    type="file"
    accept="image/*"
    hidden
    (change)="onFileSelected($event)"
  />
</div>
